import { useLocation, Link, Navigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Alert, AlertDescription } from '../components/ui/alert';
import { CheckCircle, Mail, Eye, LogIn, Ticket } from 'lucide-react';

export default function TicketSuccessPage() {
    const location = useLocation();
    const ticketData = location.state;

    // Se non ci sono dati, redirect alla home
    if (!ticketData || !ticketData.numero_ticket) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
            {/* Header */}
            <header className="bg-white border-b border-slate-200">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-xl bg-indigo-500 flex items-center justify-center">
                                <Ticket className="w-5 h-5 text-white" />
                            </div>
                            <div>
                                <h1 className="text-lg font-bold text-slate-900">Assistenza Sistema Cert Italy</h1>
                                <p className="text-xs text-slate-500">Ticket creato con successo</p>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <Card className="border-slate-200 shadow-lg">
                    <CardContent className="pt-8 pb-8">
                        <div className="text-center">
                            {/* Success Icon */}
                            <div className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-6">
                                <CheckCircle className="w-10 h-10 text-emerald-600" />
                            </div>
                            
                            {/* Title */}
                            <h2 className="text-2xl font-bold text-slate-900 mb-2">
                                Ticket Inviato con Successo!
                            </h2>
                            <p className="text-slate-600 mb-6">
                                La tua richiesta è stata ricevuta e verrà elaborata al più presto.
                            </p>
                            
                            {/* Ticket Number */}
                            <div className="bg-slate-100 rounded-xl p-6 mb-6">
                                <p className="text-sm text-slate-500 mb-2">Il tuo numero ticket</p>
                                <code className="text-2xl font-mono font-bold text-indigo-600">
                                    {ticketData.numero_ticket}
                                </code>
                            </div>
                            
                            {/* Account Created Alert */}
                            {ticketData.new_account_created && (
                                <Alert className="mb-6 bg-blue-50 border-blue-200 text-left">
                                    <Mail className="h-5 w-5 text-blue-600" />
                                    <AlertDescription className="text-blue-800 ml-2">
                                        <strong>Account creato!</strong><br />
                                        Ti abbiamo inviato le credenziali di accesso via email a <strong>{ticketData.email}</strong>.<br />
                                        Controlla anche la cartella spam.
                                    </AlertDescription>
                                </Alert>
                            )}
                            
                            {/* Info Text */}
                            <p className="text-sm text-slate-500 mb-8">
                                Riceverai aggiornamenti via email all'indirizzo {ticketData.email}
                            </p>
                            
                            {/* Action Buttons */}
                            <div className="flex flex-col sm:flex-row gap-3">
                                <Link to="/login" className="flex-1">
                                    <Button 
                                        className="w-full bg-indigo-500 hover:bg-indigo-600 h-12 text-base"
                                        data-testid="login-btn"
                                    >
                                        <LogIn className="w-5 h-5 mr-2" />
                                        Accedi al Portale
                                    </Button>
                                </Link>
                                <Link to="/richiedi-assistenza" className="flex-1">
                                    <Button 
                                        variant="outline" 
                                        className="w-full h-12 text-base"
                                        data-testid="new-ticket-btn"
                                    >
                                        Apri Nuovo Ticket
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </main>
        </div>
    );
}
